import { useMemo, useState } from 'react';

export const DEFAULT_SIDEBAR_WIDTH = 300;

export type SidebarApi = [
	{
		isOpen: boolean;
		sidebarWidth: number;
	},
	{
		toggleSidebar: () => void;
		setSidebarWidth: (width: number) => void;
	},
];

export type Props = {
	width?: number;
	defaultIsOpen?: boolean;
};

export const usePushingSidebar = ({
	width = DEFAULT_SIDEBAR_WIDTH,
	defaultIsOpen = true,
}: Props): SidebarApi => {
	const [isOpen, setIsOpen] = useState(defaultIsOpen);
	const [sidebarWidth, setSidebarWidth] = useState(width);

	const toggleSidebar = () => {
		setIsOpen((a) => !a);
	};

	return useMemo(
		() => [
			{ isOpen, sidebarWidth },
			{ toggleSidebar, setSidebarWidth },
		],
		[isOpen, sidebarWidth],
	);
};
